export default __webpack_public_path__ + "static/media/products.2aadcff0.svg";